// extracted by mini-css-extract-plugin
export var closeButton = "_p1-2";
export var closeButtonIcon = "_p1-3";
export var lightboxContent = "_p1-1";
export var lightboxOverlay = "_p1-0";